import { Link, useSearchParams } from "react-router";

import { PennText } from "@/components/ui";
import { Cad3dCompare } from "@/components/cad3d/Cad3dCompare";
import { useAppSelector } from "@/stores/hooks";

// Internal-only "3D Part Analysis" comparison (parity with the POC stepcheck.html):
// Incoming part vs the most-similar library part, side by side. No upload here —
// uploading + single preview lives on /cad/stepcheck. Reads ?applicationId=<uuid>.
// Similarity matches are internal-only (spec §6), so external users are blocked.
export const ComparePage = () => {
  const [params] = useSearchParams();
  const applicationId = params.get("applicationId");
  // Effective isInternal (user AND role, mirrors svc-09's JWT-claim gate),
  // not the raw DTO flag: ADR-0045 can set that true for an ordinary
  // external_customer whose email classifies as corporate, before an admin
  // ever promotes them to an internal role — showing this feature on that
  // flag alone would 403 against the API's own check.
  const isInternal = useAppSelector(
    (s) => (s.auth.user?.isInternal && s.auth.user?.role?.isInternal) ?? false,
  );

  return (
    <div className="w-full px-4 pt-4 pb-12 sm:px-6 lg:px-8">
      {/* <div className="mb-6 flex items-end justify-between gap-3">
        <div>
          <PennText as="h1" className="text-h1" color="on-navy">
            3D part comparison
          </PennText>
          <PennText as="p" size="base" color="on-navy-secondary" className="mt-1">
            Compare the uploaded part against the most similar parts in the
            library.
          </PennText>
        </div>
      </div> */}

      {!isInternal ? (
        <div className="rounded-2xl border border-dashed border-white/30 p-8 text-center">
          <PennText as="p" size="base" color="on-navy-secondary">
            The 3D part comparison is available to internal users only.
          </PennText>
        </div>
      ) : applicationId ? (
        <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-soft">
          <Cad3dCompare applicationId={applicationId} viewerHeight={420} />
        </div>
      ) : (
        <div className="rounded-2xl border border-dashed border-white/30 p-8 text-center">
          <PennText as="p" size="base" color="on-navy-secondary">
            No application selected. Open this page from an application to
            compare its 3D part.
          </PennText>
          <Link
            to="/installation-system"
            className="mt-3 inline-block text-button text-penn-100 hover:text-white hover:underline"
          >
            Go to applications →
          </Link>
        </div>
      )}
    </div>
  );
};
